/**
 * Nivoda gemstone collection browse (filters + product grid).
 */
window.RingBuilderGemstones = (function () {
  var NIVODA_LIVE_PROXY_BASE = "https://diamondsforeveryone.com.au/apps/nivoda";
  var NIVODA_LIVE_GEMSTONES_URL = "https://diamondsforeveryone.com.au/apps/nivoda/gemstones";
  var DEFAULT_FETCH_LIMIT = 50;
  var MIN_FETCH_LIMIT = 8;
  var MAX_FETCH_LIMIT = 100;
  var LOAD_MORE_LABEL = "Load More";
  var FILTER_RELOAD_DEBOUNCE_MS = 250;
  var state = {
    apiOffset: 0,
    totalCount: 0,
    lastPageRawCount: 0,
    lastFetchLimit: DEFAULT_FETCH_LIMIT,
    loading: false,
    pendingReload: false,
    reloadTimer: null,
    requestId: 0,
    userHasEditedFilters: false,
    items: [],
    viewMode: "grid",
  };

  var CLARITY_LABELS = {
    EC: "Eye Clean",
    EC1: "Eye Clean",
    EC2: "Eye Clean",
    SI: "Slightly Included",
    MI: "Moderately Included",
    VI1: "Visibly Included",
    VI2: "Visibly Included",
  };

  var COLOR_LABELS = {
    BI_COLOR: "Bicolor",
    MULTI_COLOR: "Multicolor",
  };

  var shapeIconUrlCache = null;

  function getRoot() {
    return document.querySelector("[data-ring-builder-gemstones]");
  }

  function parseFetchLimit(value, fallback) {
    var limit = parseInt(value, 10);
    var safeFallback = parseInt(fallback, 10);
    if (!isFinite(safeFallback)) safeFallback = DEFAULT_FETCH_LIMIT;
    if (!isFinite(limit)) return safeFallback;
    if (limit < MIN_FETCH_LIMIT) return MIN_FETCH_LIMIT;
    if (limit > MAX_FETCH_LIMIT) return MAX_FETCH_LIMIT;
    return limit;
  }

  function getFetchLimit(isAppend) {
    var config = getConfig();
    var initialLimit = parseFetchLimit(
      config.initialLimit,
      DEFAULT_FETCH_LIMIT,
    );
    if (isAppend) {
      return parseFetchLimit(config.loadMoreLimit, initialLimit);
    }
    return initialLimit;
  }

  function getShopDomain() {
    var root = getRoot();
    if (root && root.getAttribute("data-shop")) {
      return root.getAttribute("data-shop");
    }
    var scoped = document.querySelector("[data-ring-builder-gemstones][data-shop]");
    return scoped ? scoped.getAttribute("data-shop") : "";
  }

  function resolveDevProxyBase() {
    var root = getRoot();
    var container =
      (root && root.closest("[data-nivoda-dev-proxy-base]")) ||
      document.querySelector("[data-nivoda-dev-proxy-base]");
    var base = container ? container.getAttribute("data-nivoda-dev-proxy-base") : "";
    return base ? base.replace(/\/$/, "") : "";
  }

  function usesDirectDevProxy(url) {
    return /^https?:\/\//i.test(url || "");
  }

  function getConfig() {
    var root = getRoot();
    if (!root) return {};
    var proxyUrl =
      root.getAttribute("data-nivoda-proxy-url") ||
      NIVODA_LIVE_GEMSTONES_URL;
    var devBase = resolveDevProxyBase();
    if (devBase) {
      proxyUrl = devBase + "/gemstones";
    }
    proxyUrl = proxyUrl.replace(/\?.*$/, "");
    return {
      proxyUrl: proxyUrl,
      usesDirectDevProxy: usesDirectDevProxy(proxyUrl),
      gridClass: root.getAttribute("data-gemstone-grid-class") || "col-sm-6 col-lg-3",
      initialLimit: root.getAttribute("data-gemstone-initial-limit"),
      loadMoreLimit: root.getAttribute("data-gemstone-load-more-limit"),
    };
  }

  function getFilterDefaults() {
    var el = document.getElementById("GemstoneFilterOptionsConfig");
    if (!el) {
      return { priceMin: 1, priceMax: 5000000, caratMin: 1, caratMax: 10 };
    }
    try {
      var cfg = JSON.parse(el.textContent);
      return cfg.defaults || {};
    } catch (e) {
      return { priceMin: 1, priceMax: 5000000, caratMin: 1, caratMax: 10 };
    }
  }

  var RESERVED_QUERY_KEYS = ["step", "flow", "_fd", "ring-builder", "preview_theme_id", "pb"];

  var GEMSTONE_FILTER_URL_KEYS = [
    "Variety",
    "Shape",
    "PriceFrom",
    "PriceTo",
    "CaratFrom",
    "CaratTo",
    "Color",
    "Cut",
    "Clarity",
    "Sort",
  ];

  var FALLBACK_GEMSTONE_SORT = "price_asc";

  var GEMSTONE_SORT_LABELS = {
    price_desc: "Price: High to Low",
    price_asc: "Price: Low to High",
    price_per_carat_desc: "Price per carat: High to Low",
    price_per_carat_asc: "Price per carat: Low to High",
    carats_desc: "Carat: High to Low",
    carats_asc: "Carat: Low to High",
  };

  function getDefaultGemstoneSort() {
    var root = getRoot();
    var fromDom = root && root.getAttribute("data-default-sort");
    var key = String(fromDom || FALLBACK_GEMSTONE_SORT)
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
    return GEMSTONE_SORT_LABELS[key] ? key : FALLBACK_GEMSTONE_SORT;
  }

  function normalizeGemstoneSort(value) {
    var key = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, "_");
    return GEMSTONE_SORT_LABELS[key] ? key : getDefaultGemstoneSort();
  }

  function getGemstoneSortLabel(value) {
    return GEMSTONE_SORT_LABELS[normalizeGemstoneSort(value)] || GEMSTONE_SORT_LABELS[getDefaultGemstoneSort()];
  }

  function setGemstoneSortMenuOpen(isOpen) {
    var root = getRoot();
    if (!root) return;
    var sortRoot = root.querySelector("[data-gemstone-sort]");
    var trigger = root.querySelector("[data-gemstone-sort-trigger]");
    var menu = root.querySelector("[data-gemstone-sort-menu]");
    if (!sortRoot || !trigger || !menu) return;

    sortRoot.classList.toggle("is-open", !!isOpen);
    trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    menu.hidden = !isOpen;
  }

  function applySortFilter(sortValue) {
    var root = getRoot();
    if (!root) return;
    var normalized = normalizeGemstoneSort(sortValue);
    var sortInput = root.querySelector('[data-gemstone-filter="sort"]');
    var labelEl = root.querySelector("[data-gemstone-sort-label]");

    if (sortInput) sortInput.value = normalized;
    if (labelEl) labelEl.textContent = getGemstoneSortLabel(normalized);

    root.querySelectorAll("[data-gemstone-sort-option]").forEach(function (btn) {
      var active = normalizeGemstoneSort(btn.getAttribute("data-sort")) === normalized;
      btn.classList.toggle("is-selected", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  function getFilterDefaultsNormalized() {
    var defaults = getFilterDefaults();
    return {
      price_min: Number(defaults.priceMin) || 1,
      price_max: Number(defaults.priceMax) || 5000000,
      carat_min: Number(defaults.caratMin) || 1,
      carat_max: Number(defaults.caratMax) || 10,
    };
  }

  function parseFilterNumber(value, fallback) {
    var num = parseFloat(value);
    return isFinite(num) ? num : fallback;
  }

  function isFullRange(minVal, maxVal, defMin, defMax) {
    var min = parseFilterNumber(minVal, defMin);
    var max = parseFilterNumber(maxVal, defMax);
    return min <= defMin && max >= defMax;
  }

  function getUrlParam(params) {
    var keys = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < keys.length; i++) {
      var val = params.get(keys[i]);
      if (val) return val;
    }
    return "";
  }

  function hasGemstoneFilterParams(params) {
    return GEMSTONE_FILTER_URL_KEYS.some(function (key) {
      return params.has(key);
    });
  }

  function shapeFromUrlValue(urlShape) {
    if (!urlShape) return "";
    return String(urlShape).trim().toUpperCase().replace(/[\s-]+/g, "_");
  }

  function shapeToUrlValue(apiShape) {
    if (!apiShape) return "";
    return String(apiShape)
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function parseUrlToFilters() {
    var params = new URLSearchParams(window.location.search);
    if (!hasGemstoneFilterParams(params)) return null;

    return {
      variety: getUrlParam(params, "Variety").toUpperCase(),
      shape: shapeFromUrlValue(getUrlParam(params, "Shape")),
      price_min: getUrlParam(params, "PriceFrom"),
      price_max: getUrlParam(params, "PriceTo"),
      carat_min: getUrlParam(params, "CaratFrom"),
      carat_max: getUrlParam(params, "CaratTo"),
      color: getUrlParam(params, "Color").toUpperCase(),
      clarity: getUrlParam(params, "Clarity").toUpperCase(),
      cut: getUrlParam(params, "Cut").toUpperCase(),
      sort: normalizeGemstoneSort(getUrlParam(params, "Sort")),
    };
  }

  function filtersToUrlSearchParams(filters) {
    var defaults = getFilterDefaultsNormalized();
    var next = new URLSearchParams();
    var current = new URLSearchParams(window.location.search);

    RESERVED_QUERY_KEYS.forEach(function (key) {
      var val = current.get(key);
      if (val) next.set(key, val);
    });

    if (filters.variety) next.set("Variety", filters.variety);
    if (filters.shape) next.set("Shape", shapeToUrlValue(filters.shape));

    if (!isFullRange(filters.price_min, filters.price_max, defaults.price_min, defaults.price_max)) {
      if (filters.price_min) next.set("PriceFrom", String(filters.price_min));
      if (filters.price_max) next.set("PriceTo", String(filters.price_max));
    }

    if (!isFullRange(filters.carat_min, filters.carat_max, defaults.carat_min, defaults.carat_max)) {
      if (filters.carat_min) next.set("CaratFrom", String(filters.carat_min));
      if (filters.carat_max) next.set("CaratTo", String(filters.carat_max));
    }

    if (filters.color) next.set("Color", filters.color);
    if (filters.clarity) next.set("Clarity", filters.clarity);
    if (filters.cut) next.set("Cut", filters.cut);
    next.set("Sort", normalizeGemstoneSort(filters.sort));

    return next;
  }

  function syncFiltersToUrl(filters) {
    var url = new URL(window.location.href);
    var qs = filtersToUrlSearchParams(filters || {}).toString();
    var nextUrl = url.pathname + (qs ? "?" + qs : "");
    if (nextUrl === url.pathname + url.search) return;
    history.replaceState(history.state || {}, "", nextUrl);
  }

  function syncUrlFromUi() {
    syncFiltersToUrl(getFilters());
  }

  function markFiltersEdited() {
    state.userHasEditedFilters = true;
    var root = getRoot();
    if (root) root.dataset.filtersBootstrapped = "true";
  }

  function cancelScheduledFilterReload() {
    if (state.reloadTimer) {
      clearTimeout(state.reloadTimer);
      state.reloadTimer = null;
    }
  }

  /**
   * Keep the URL in sync on every UI change, but coalesce rapid multi-selects
   * into one API request with the final CSV (Color=D,E,F etc.).
   */
  function scheduleFilterReload() {
    markFiltersEdited();
    syncUrlFromUi();
    cancelScheduledFilterReload();
    state.reloadTimer = setTimeout(function () {
      state.reloadTimer = null;
      loadGemstones(false);
    }, FILTER_RELOAD_DEBOUNCE_MS);
  }

  function flushFilterReload() {
    cancelScheduledFilterReload();
    syncUrlFromUi();
    return loadGemstones(false);
  }

  function setPillGroupValues(groupKey, valuesCsv) {
    var root = getRoot();
    if (!root) return;
    var values = valuesCsv
      ? valuesCsv.split(",").map(function (v) { return v.trim().toUpperCase(); }).filter(Boolean)
      : [];
    root.querySelectorAll('[data-gemstone-pill-group="' + groupKey + '"] .rb-filter-pill').forEach(function (pill) {
      var pillVal = (pill.getAttribute("data-pill-value") || "").toUpperCase();
      pill.classList.toggle("is-active", values.indexOf(pillVal) !== -1);
    });
    root.querySelectorAll('[data-gemstone-filter="' + groupKey + '"]').forEach(function (hidden) {
      hidden.value = valuesCsv || "";
    });
  }

  function applyShapeFilter(shapeApi) {
    var root = getRoot();
    if (!root) return;
    var normalized = shapeApi ? String(shapeApi).toUpperCase() : "";
    root.querySelectorAll("[data-gemstone-shape-swatch]").forEach(function (btn) {
      var shape = (btn.getAttribute("data-shape") || "").toUpperCase();
      var active = normalized && shape === normalized;
      btn.classList.toggle("is-active", active);
      btn.classList.toggle("is-selected", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
    var hidden = root.querySelector('[data-gemstone-filter="shape"]');
    if (hidden) hidden.value = normalized;
  }

  function setSliderRange(sliderId, minVal, maxVal, fallbackMin, fallbackMax) {
    var root = getRoot();
    var slider = root ? root.querySelector(sliderId) : null;
    if (!slider || !slider.noUiSlider) return;
    var min = parseFloat(minVal);
    var max = parseFloat(maxVal);
    if (!isFinite(min)) min = fallbackMin;
    if (!isFinite(max)) max = fallbackMax;
    slider.noUiSlider.set([min, max]);
  }

  function setRangeFilter(minKey, maxKey, minVal, maxVal) {
    var root = getRoot();
    if (!root) return;
    if (minVal != null && minVal !== "") {
      root.querySelectorAll('[data-gemstone-filter="' + minKey + '"], [data-gemstone-range="' + minKey + '"]').forEach(function (el) {
        el.value = minVal;
      });
    }
    if (maxVal != null && maxVal !== "") {
      root.querySelectorAll('[data-gemstone-filter="' + maxKey + '"], [data-gemstone-range="' + maxKey + '"]').forEach(function (el) {
        el.value = maxVal;
      });
    }
  }

  function applyFiltersToUi(filters) {
    var root = getRoot();
    if (!root || !filters) return;
    var defaults = getFilterDefaultsNormalized();

    setPillGroupValues("variety", filters.variety || "");
    applyShapeFilter(filters.shape || "");
    setPillGroupValues("color", filters.color || "");
    setPillGroupValues("cut", filters.cut || "");
    setPillGroupValues("clarity", filters.clarity || "");

    var priceMin = filters.price_min !== "" && filters.price_min != null ? filters.price_min : defaults.price_min;
    var priceMax = filters.price_max !== "" && filters.price_max != null ? filters.price_max : defaults.price_max;
    setRangeFilter("price_min", "price_max", priceMin, priceMax);
    setSliderRange("#gemstone-price-slider", priceMin, priceMax, defaults.price_min, defaults.price_max);

    var caratMin = filters.carat_min !== "" && filters.carat_min != null ? filters.carat_min : defaults.carat_min;
    var caratMax = filters.carat_max !== "" && filters.carat_max != null ? filters.carat_max : defaults.carat_max;
    setRangeFilter("carat_min", "carat_max", caratMin, caratMax);
    setSliderRange("#gemstone-carat-slider", caratMin, caratMax, defaults.carat_min, defaults.carat_max);

    applySortFilter(filters.sort || getDefaultGemstoneSort());
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getGemstoneSearchLayoutElements(root) {
    root = root || getRoot();
    if (!root) return [];
    return [
      root.querySelector(".ring-builder-gemstones__filters-wrap"),
      root.querySelector(".ring-builder-gemstones__results-header"),
      root.querySelector(".ring-builder-gemstones__results"),
      root.querySelector(".ring-builder-diamonds__load-more-wrap"),
      root.querySelector("[data-gemstone-result-meta]"),
      root.querySelector("[data-gemstone-notice]"),
    ].filter(Boolean);
  }

  function showGemstoneSearchLayout(root) {
    root = root || getRoot();
    if (!root) return;
    var detailView = document.getElementById("GemstoneDetailView");
    if (detailView) detailView.style.display = "none";
    getGemstoneSearchLayoutElements(root).forEach(function (el) {
      el.style.removeProperty("display");
    });
    updateResultMeta();
  }

  function hideGemstoneSearchLayout(root) {
    root = root || getRoot();
    if (!root) return;
    getGemstoneSearchLayoutElements(root).forEach(function (el) {
      el.style.display = "none";
    });
  }

  function formatCaratDisplay(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "—";
    if (value % 1 === 0) return value.toFixed(1);
    return value.toFixed(2).replace(/\.?0+$/, "");
  }

  function formatLengthWidth(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    if (!isFinite(length) || !isFinite(width)) return "—";
    return length.toFixed(2) + " × " + width.toFixed(2);
  }

  function formatDimensions(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    var depth = Number(item.depth);
    if (!isFinite(length) || !isFinite(width) || !isFinite(depth)) return "";
    return length.toFixed(2) + " x " + width.toFixed(2) + " x " + depth.toFixed(2);
  }

  function formatGemstoneRatio(item) {
    var length = Number(item.length);
    var width = Number(item.width);
    if (!isFinite(length) || !isFinite(width) || width <= 0) return "—";
    return (length / width).toFixed(2);
  }

  function formatDeliveryRange(minDays, maxDays) {
    var min = Number(minDays) || 30;
    var max = Number(maxDays) || 35;
    var now = new Date();
    var start = new Date(now);
    var end = new Date(now);
    start.setDate(start.getDate() + min);
    end.setDate(end.getDate() + max);
    var fmt = function (date) {
      return date.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
    };
    return fmt(start) + " – " + fmt(end);
  }

  function getGemstoneMediaEmbedSize(mediaContainer) {
    var cssWidth = Math.floor(mediaContainer ? mediaContainer.clientWidth || 0 : 0);
    var cssHeight = Math.floor(mediaContainer ? mediaContainer.clientHeight || 0 : 0);
    if ((cssWidth < 50 || cssHeight < 50) && mediaContainer) {
      var mediaMain = mediaContainer.closest(".diamond-detail-view__media-main");
      if (mediaMain) {
        var rect = mediaMain.getBoundingClientRect();
        cssWidth = Math.floor(rect.width || mediaMain.clientWidth || 0);
        cssHeight = Math.floor(rect.height || mediaMain.clientHeight || 0);
      }
    }
    return { width: Math.max(200, cssWidth), height: Math.max(200, cssHeight) };
  }

  function resizeNivodaMediaUrl(url, width, height) {
    if (!url) return url;
    var w = Math.max(200, Math.round(width || 500));
    var h = Math.max(200, Math.round(height || w));
    return String(url).replace(/\/(video|image)\/(\d+)\/(\d+)(?=[/?#]|$)/i, function (_match, type) {
      return "/" + type + "/" + w + "/" + h;
    });
  }

  function isDirectImageUrl(url) {
    return /\.(png|jpe?g|webp|gif|avif)(\?|$)/i.test(String(url || ""));
  }

  function getShapeIconUrls() {
    if (shapeIconUrlCache) return shapeIconUrlCache;
    var el = document.getElementById("ring-builder-shape-icons");
    if (!el) {
      shapeIconUrlCache = {};
      return shapeIconUrlCache;
    }
    try {
      shapeIconUrlCache = JSON.parse(el.textContent);
    } catch (e) {
      shapeIconUrlCache = {};
    }
    return shapeIconUrlCache;
  }

  function normalizeShapeKey(shape) {
    return String(shape || "ROUND")
      .toUpperCase()
      .replace(/[\s-]+/g, "_");
  }

  function getShapeIconUrl(shape) {
    var urls = getShapeIconUrls();
    var key = normalizeShapeKey(shape);
    var aliases = {
      SQ_EMERALD: "EMERALD",
      SQ_RADIANT: "RADIANT",
      CUSHION_ALL: "CUSHION",
      CUSHION_BRILLIANT: "CUSHION",
      SQUARE: "PRINCESS",
      OCTAGONAL: "EMERALD",
      TRILLIANT: "PEAR",
      OTHER: "ROUND",
    };
    if (aliases[key] && urls[aliases[key]]) return urls[aliases[key]];
    if (urls[key]) return urls[key];
    if (key.indexOf("CUSHION") === 0 && urls.CUSHION) return urls.CUSHION;
    var base = key.split("_")[0];
    return urls[base] || urls.ROUND || "";
  }

  function getDiamondPlaceholderUrl() {
    if (window.__dfeDiamondPlaceholderUrl) return window.__dfeDiamondPlaceholderUrl;
    var scoped = document.querySelector("[data-diamond-placeholder-url]");
    if (scoped) {
      window.__dfeDiamondPlaceholderUrl =
        scoped.getAttribute("data-diamond-placeholder-url") || "";
      return window.__dfeDiamondPlaceholderUrl;
    }
    var tplImg = document.querySelector(
      "#gemstone-card-ub-template .ub-gemstone-card__placeholder-icon, #diamond-card-ub-template .ub-diamond-card__placeholder-icon",
    );
    window.__dfeDiamondPlaceholderUrl = tplImg
      ? tplImg.getAttribute("src") || ""
      : "";
    return window.__dfeDiamondPlaceholderUrl;
  }

  function renderDiamondPlaceholderImage(className, altText) {
    var url = getDiamondPlaceholderUrl();
    if (!url) return "";
    return (
      '<img class="' +
      escapeHtml(className || "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder") +
      '" src="' +
      escapeHtml(url) +
      '" alt="' +
      escapeHtml(altText || "") +
      '">'
    );
  }

  function getGemstoneCardMediaUrl(item) {
    var image = item.image && String(item.image).trim();
    if (image && isDirectImageUrl(image)) {
      return { url: resizeNivodaMediaUrl(image, 600, 600), fallback: false, hasVideo: !!item.video };
    }

    return {
      url: getDiamondPlaceholderUrl(),
      fallback: true,
      hasVideo: !!item.video,
    };
  }

  function setGemstoneFieldVisibility(card, field, visible) {
    var el = card.querySelector('[data-gemstone-field="' + field + '"]');
    if (el) el.hidden = !visible;
  }

  function buildSpecsTableHtml(specs) {
    return specs.map(function (spec) {
      return "<tr><td>" + escapeHtml(spec.label) + "</td><td>" + escapeHtml(spec.value || "—") + "</td></tr>";
    }).join("");
  }

  function buildGemstoneDescriptionHtml(item) {
    var title = formatGemstoneTitle(item);
    var intro =
      "<p>This " +
      escapeHtml(title) +
      " is sourced through Nivoda" +
      (item.lab ? " and certified by " + escapeHtml(item.lab) : "") +
      (item.certNumber ? " (report #" + escapeHtml(item.certNumber) + ")" : "") +
      ".</p>";

    var specsLeft = [
      { label: "Variety", value: formatLabel(item.gemType) },
      { label: "Shape", value: formatLabel(item.shape) },
      { label: "Carat Weight", value: formatCarats(item.carats) },
      { label: "Color", value: formatLabel(item.color, COLOR_LABELS) },
      { label: "Clarity", value: formatLabel(item.clarity, CLARITY_LABELS) },
      { label: "Cut", value: formatLabel(item.cut) },
    ];
    var specsRight = [
      { label: "Lab", value: item.lab || "—" },
      { label: "Certificate Number", value: item.certNumber || "—" },
      { label: "Dimensions", value: formatDimensions(item) || "—" },
      { label: "Treatment", value: formatLabel(item.treatment) },
      { label: "Stock Number", value: item.offerId || item.gemstoneId || "—" },
      { label: "Origin", value: "Natural Gemstone" },
    ];

    return (
      intro +
      '<div class="rb-complete-specs-grid">' +
      '<div><table class="table table-sm table-borderless" style="margin: 0; width: 100%;"><tbody>' +
      buildSpecsTableHtml(specsLeft) +
      "</tbody></table></div>" +
      '<div><table class="table table-sm table-borderless" style="margin: 0; width: 100%;"><tbody>' +
      buildSpecsTableHtml(specsRight) +
      "</tbody></table></div>" +
      "</div>"
    );
  }

  function formatLabel(value, map) {
    if (!value) return "—";
    var key = String(value).toUpperCase();
    if (map && map[key]) return map[key];
    return String(value)
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function formatPrice(price) {
    if (window.RingBuilderDiamondMargin) {
      return window.RingBuilderDiamondMargin.formatRetailMoney(price);
    }

    var amount = Number(price);
    if (!isFinite(amount)) return "";

    var dollars = Math.round(amount / 100);
    if (
      window.theme &&
      window.theme.Currency &&
      typeof window.theme.Currency.formatMoney === "function"
    ) {
      var format = String(window.theme.moneyFormat || "${{amount}}").replace(
        /\{\{\s*amount\s*\}\}/g,
        "{{amount_no_decimals}}",
      );
      return window.theme.Currency.formatMoney(dollars * 100, format);
    }

    return "$" + dollars.toLocaleString();
  }

  function formatCompareAtPrice(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.formatCompareAtMoney === "function"
    ) {
      return window.RingBuilderDiamondMargin.formatCompareAtMoney(price);
    }
    return "";
  }

  function formatTablePrice(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.formatRetailMoneyRounded === "function"
    ) {
      return window.RingBuilderDiamondMargin.formatRetailMoneyRounded(price);
    }
    return formatPrice(price) || "—";
  }

  function formatTableCompareAt(price) {
    if (
      window.RingBuilderDiamondMargin &&
      typeof window.RingBuilderDiamondMargin.formatCompareAtMoneyRounded === "function"
    ) {
      var text = window.RingBuilderDiamondMargin.formatCompareAtMoneyRounded(price);
      if (text) {
        return (
          ' <s class="ring-builder-diamonds__table-price-compare">' +
          escapeHtml(text) +
          "</s>"
        );
      }
    }
    return "";
  }

  function formatCarats(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return "";
    var text = value % 1 === 0 ? value.toFixed(2) : value.toFixed(2).replace(/\.?0+$/, "");
    return text + "ct";
  }

  function formatGemstoneCardTitle(item) {
    var carats = Number(item.carats);
    var caratLabel = isFinite(carats)
      ? (carats % 1 === 0 ? String(carats) : carats.toFixed(2).replace(/\.?0+$/, ""))
      : "";
    var shape = formatLabel(item.shape);
    var variety = formatLabel(item.gemType);
    return (caratLabel ? caratLabel + " Carat " : "") + shape + " Natural " + variety;
  }

  function formatGemstoneCertSummary(item) {
    var parts = [];
    if (item.color) parts.push(formatLabel(item.color, COLOR_LABELS));
    if (item.clarity) parts.push(formatLabel(item.clarity, CLARITY_LABELS));
    var lab = String(item.lab || "").trim();
    if (lab && lab.toUpperCase() !== "NONE") parts.push(lab.toUpperCase() + " Certified");
    return parts.join(" · ");
  }

  function formatGemstoneTitle(item) {
    return formatGemstoneCardTitle(item);
  }

  function formatGemstoneDetails(item) {
    return (
      "Colour: " + formatLabel(item.color, COLOR_LABELS) +
      ", Clarity: " + formatLabel(item.clarity, CLARITY_LABELS) +
      ", Cut: " + formatLabel(item.cut)
    );
  }

  function formatCertLabel(item) {
    var lab = String(item.lab || "").trim().toUpperCase();
    if (!lab || lab === "NONE") return "";
    return lab + " Certified";
  }

  function buildCertificateUrl(item) {
    var cert = String(item.certNumber || item.offerId || "").trim();
    if (!cert) return "";
    var lab = String(item.lab || "").toUpperCase();
    if (lab === "GIA") {
      return "https://www.gia.edu/report-check?reportno=" + encodeURIComponent(cert);
    }
    if (lab === "IGI") {
      return "https://www.igi.org/verify.php?r=" + encodeURIComponent(cert);
    }
    return "";
  }

  function buildCertificateLabel(item) {
    var lab = String(item.lab || "").trim().toUpperCase();
    if (!lab || lab === "NONE") return "Certified Gemstone";
    var cert = String(item.certNumber || "").trim();
    if (cert) return lab + " #" + cert;
    return lab + " Certified";
  }

  function appendCertificateThumbButton(mediaThumbs, item) {
    if (!mediaThumbs || !item) return;

    var certUrl = buildCertificateUrl(item);
    if (!certUrl) return;

    var certBtn = document.createElement("a");
    certBtn.href = certUrl;
    certBtn.target = "_blank";
    certBtn.rel = "noopener noreferrer";
    certBtn.className = "diamond-detail-view__media-thumb--certificate";
    certBtn.textContent = "View Certificate";
    certBtn.setAttribute("aria-label", "View " + buildCertificateLabel(item));
    mediaThumbs.appendChild(certBtn);
  }

  function populateDetailLabBadgeLink(detailView, item) {
    if (!detailView || !item) return;

    var certUrl = buildCertificateUrl(item);
    var labBadgeEl = detailView.querySelector("[data-gemstone-detail-lab-badge]");
    if (!labBadgeEl) return;

    labBadgeEl.textContent = formatCertLabel(item) || "Certified Gemstone";
    if (certUrl) {
      labBadgeEl.href = certUrl;
      labBadgeEl.target = "_blank";
      labBadgeEl.rel = "noopener noreferrer";
      labBadgeEl.classList.remove("diamond-lab-badge--static");
      labBadgeEl.removeAttribute("aria-disabled");
    } else {
      labBadgeEl.removeAttribute("href");
      labBadgeEl.removeAttribute("target");
      labBadgeEl.removeAttribute("rel");
      labBadgeEl.classList.add("diamond-lab-badge--static");
      labBadgeEl.setAttribute("aria-disabled", "true");
    }
  }

  function getGrid() {
    var root = getRoot();
    return root ? root.querySelector("[data-gemstone-grid]") : null;
  }

  var PROMO_FIRST_AFTER_PRODUCTS = 8;
  var PROMO_SUBSEQUENT_GAP = 8;
  var PROMO_ANCHOR = 8;
  var PROMO_THRESHOLD = 16;

  function isGemstoneGridPromosEnabled() {
    var root = getRoot();
    return !!(root && root.getAttribute("data-gemstone-grid-promos-enabled") === "true");
  }

  function getPromoNumberForSlot(productsBefore, gridPosition) {
    if (productsBefore === PROMO_FIRST_AFTER_PRODUCTS) return 1;
    if (gridPosition >= PROMO_THRESHOLD) {
      var gridBeforePromo = gridPosition - PROMO_ANCHOR;
      if (gridBeforePromo % PROMO_SUBSEQUENT_GAP === 0) {
        var promoNum = Math.floor(gridBeforePromo / PROMO_SUBSEQUENT_GAP) + 1;
        if (promoNum <= 10) return promoNum;
      }
    }
    return 0;
  }

  function clonePromoNode(promoNum) {
    var root = getRoot();
    if (!root) return null;
    var template = root.querySelector(
      '[data-gemstone-grid-promo-template="' + promoNum + '"]',
    );
    if (!template || !template.content) return null;
    var node = template.content.firstElementChild;
    if (!node) return null;
    return node.cloneNode(true);
  }

  function appendPromoIfNeeded(grid, productsBefore, gridPosition) {
    if (!isGemstoneGridPromosEnabled() || !grid) return gridPosition;

    var promoNum = getPromoNumberForSlot(productsBefore, gridPosition);
    if (!promoNum) return gridPosition;

    var promoNode = clonePromoNode(promoNum);
    if (!promoNode) return gridPosition;

    grid.appendChild(promoNode);
    return gridPosition + 1;
  }

  function getTableBody() {
    var root = getRoot();
    return root ? root.querySelector("[data-gemstone-table-body]") : null;
  }


  function getFilters() {
    var root = getRoot();
    if (!root) return {};

    var result = {};
    root.querySelectorAll("[data-gemstone-filter]").forEach(function (input) {
      var key = input.getAttribute("data-gemstone-filter");
      if (key) result[key] = input.value || "";
    });
    return result;
  }

  function buildProxyUrl(filters, offset, limit) {
    var config = getConfig();
    var defaults = getFilterDefaultsNormalized();
    var fetchLimit = parseFetchLimit(limit, getFetchLimit(false));
    var params = new URLSearchParams({
      offset: String(offset),
      limit: String(fetchLimit),
    });

    ["variety", "shape", "color", "clarity", "cut"].forEach(function (key) {
      if (filters[key]) params.set(key, filters[key]);
    });
    if (!isFullRange(filters.carat_min, filters.carat_max, defaults.carat_min, defaults.carat_max)) {
      if (filters.carat_min) params.set("carat_min", filters.carat_min);
      if (filters.carat_max) params.set("carat_max", filters.carat_max);
    }
    if (!isFullRange(filters.price_min, filters.price_max, defaults.price_min, defaults.price_max)) {
      if (filters.price_min) params.set("price_min", filters.price_min);
      if (filters.price_max) params.set("price_max", filters.price_max);
    }
    params.set("sort", normalizeGemstoneSort(filters.sort));

    if (config.usesDirectDevProxy) {
      var shop = getShopDomain();
      if (shop) params.set("shop", shop);
    }

    return config.proxyUrl + "?" + params.toString();
  }

  function setPanelMessage(message, isError) {
    var root = getRoot();
    if (!root) return;
    var notice = root.querySelector("[data-gemstone-notice]");
    if (!notice) return;
    if (!message) {
      notice.hidden = true;
      notice.textContent = "";
      return;
    }
    notice.hidden = false;
    notice.textContent = message;
    notice.classList.toggle("is-error", !!isError);
  }

  function setLoading(loading, append) {
    state.loading = loading;
    var root = getRoot();
    if (!root) return;

    var loadingEl = root.querySelector("[data-gemstone-loading]");
    var skeleton = root.querySelector("[data-gemstone-skeleton]");
    var results = root.querySelector(".ring-builder-gemstones__results");
    var loadMoreBtn = root.querySelector("[data-gemstone-load-more]");

    if (loading && !append) {
      if (loadingEl) loadingEl.hidden = false;
      if (skeleton) skeleton.hidden = false;
      if (results) results.style.display = "none";
    } else {
      if (loadingEl) loadingEl.hidden = true;
      if (skeleton) skeleton.hidden = true;
      if (results) results.style.removeProperty("display");
    }

    if (loadMoreBtn) {
      loadMoreBtn.disabled = loading;
      if (!loading) loadMoreBtn.textContent = LOAD_MORE_LABEL;
    }
  }

  function populateCard(card, item) {
    var payload = JSON.stringify(item);
    var title = formatGemstoneCardTitle(item);
    var media = getGemstoneCardMediaUrl(item);

    card.setAttribute("data-offer-id", item.offerId || "");
    card.setAttribute("data-gemstone-payload", payload);
    card.classList.toggle("ub-gemstone-card--has-video", !!media.hasVideo);

    var certEl = card.querySelector('[data-gemstone-field="cert"]');
    if (certEl) certEl.textContent = formatGemstoneCertSummary(item);

    var titleEl = card.querySelector('[data-gemstone-field="title"]');
    if (titleEl) titleEl.textContent = title;

    var priceEl = card.querySelector('[data-gemstone-field="price"]');
    if (priceEl) priceEl.textContent = formatPrice(item.price);

    var compareEl = card.querySelector('[data-gemstone-field="compare-at"]');
    if (compareEl) {
      var compareText = formatCompareAtPrice(item.price);
      compareEl.textContent = compareText || "";
      compareEl.hidden = !compareText;
    }

    var imageEl = card.querySelector('[data-gemstone-field="image"]');
    if (imageEl) {
      imageEl.onload = null;
      imageEl.onerror = null;
      imageEl.classList.remove("ub-gemstone-card__image--placeholder");

      if (media.url) {
        imageEl.src = media.url;
        imageEl.alt = title;
        imageEl.hidden = false;
        imageEl.classList.toggle("ub-gemstone-card__image--placeholder", media.fallback);
        setGemstoneFieldVisibility(card, "image-placeholder", false);

        imageEl.onerror = function () {
          imageEl.onerror = null;
          var failedUrl = imageEl.src;
          var placeholderUrl = getDiamondPlaceholderUrl();
          if (!media.fallback && placeholderUrl && failedUrl !== placeholderUrl) {
            imageEl.src = placeholderUrl;
            imageEl.classList.add("ub-gemstone-card__image--placeholder");
            imageEl.hidden = false;
            setGemstoneFieldVisibility(card, "image-placeholder", false);
            return;
          }
          imageEl.hidden = true;
          imageEl.removeAttribute("src");
          setGemstoneFieldVisibility(card, "image-placeholder", true);
        };
      } else {
        imageEl.hidden = true;
        imageEl.removeAttribute("src");
        setGemstoneFieldVisibility(card, "image-placeholder", true);
      }
    }

    var selectBtn = card.querySelector("[data-gemstone-select]");
    if (selectBtn) selectBtn.setAttribute("data-gemstone-payload", payload);
  }

  function createCardNode(item) {
    var template = document.getElementById("gemstone-card-ub-template");
    if (!template || !template.content) return null;
    var config = getConfig();
    var node = template.content.firstElementChild.cloneNode(true);
    if (config.gridClass) {
      config.gridClass.split(/\s+/).forEach(function (cls) {
        if (cls) node.classList.add(cls);
      });
    }
    populateCard(node, item);
    return node;
  }

  function getTableShapeFallbackHtml(item) {
    var iconUrl = getShapeIconUrl(item.shape);
    if (iconUrl) {
      return (
        '<img class="ring-builder-diamonds__table-shape-img" src="' +
        escapeHtml(iconUrl) +
        '" alt="" width="20" height="20" loading="lazy">'
      );
    }

    var placeholderUrl = getDiamondPlaceholderUrl();
    if (placeholderUrl) {
      return (
        '<img class="ring-builder-diamonds__table-diamond-img" src="' +
        escapeHtml(placeholderUrl) +
        '" alt="" width="48" height="48" loading="lazy" data-gemstone-table-image-fallback="true">'
      );
    }

    return (
      '<span class="ring-builder-diamonds__table-shape-icon" aria-hidden="true">◆</span>'
    );
  }

  function getTableThumbHtml(item, shapeLabel) {
    var media = getGemstoneCardMediaUrl(item);
    var thumbUrl = media.url || "";
    if (thumbUrl) {
      return (
        '<img class="ring-builder-diamonds__table-diamond-img" src="' +
        escapeHtml(thumbUrl) +
        '" alt="' +
        escapeHtml(shapeLabel) +
        '" width="48" height="48" loading="lazy" data-gemstone-table-image' +
        (media.fallback ? ' data-gemstone-table-image-fallback="true"' : "") +
        ">"
      );
    }

    return getTableShapeFallbackHtml(item);
  }

  function bindTableRowImageFallback(row, item) {
    if (!row || !item) return;
    var img = row.querySelector("[data-gemstone-table-image]");
    if (!img) return;

    img.addEventListener("error", function onTableImageError() {
      img.removeEventListener("error", onTableImageError);

      if (!img.getAttribute("data-gemstone-table-image-fallback")) {
        var placeholderUrl = getDiamondPlaceholderUrl();
        if (placeholderUrl && img.src !== placeholderUrl) {
          img.setAttribute("data-gemstone-table-image-fallback", "true");
          img.src = placeholderUrl;
          return;
        }
      }

      var fallback = document.createElement("div");
      fallback.innerHTML = getTableShapeFallbackHtml(item);
      var replacement = fallback.firstElementChild;
      if (replacement) img.replaceWith(replacement);
    });
  }

  function renderTableRow(item) {
    var payload = escapeHtml(JSON.stringify(item));
    var shapeLabel = formatLabel(item.shape);
    var iconHtml = getTableThumbHtml(item, shapeLabel);

    return (
      '<tr data-gemstone-card data-offer-id="' +
      escapeHtml(item.offerId) +
      '" tabindex="0" role="row" data-gemstone-payload="' +
      payload +
      '">' +
      '<td><div class="ring-builder-diamonds__table-shape">' +
      iconHtml +
      '<span class="ring-builder-diamonds__table-shape-name">' +
      escapeHtml(shapeLabel) +
      "</span>" +
      "</div></td>" +
      "<td>" +
      escapeHtml(formatCarats(item.carats)) +
      "</td>" +
      "<td>" +
      escapeHtml(formatLabel(item.color, COLOR_LABELS)) +
      "</td>" +
      "<td>" +
      escapeHtml(formatLabel(item.clarity, CLARITY_LABELS)) +
      "</td>" +
      "<td>" +
      escapeHtml(formatLabel(item.cut)) +
      "</td>" +
      "<td>" +
      escapeHtml(formatCertLabel(item) || "—") +
      "</td>" +
      "<td>" +
      '<span class="ring-builder-diamonds__table-price-current">' +
      escapeHtml(formatTablePrice(item.price)) +
      "</span>" +
      formatTableCompareAt(item.price) +
      "</td>" +
      "</tr>"
    );
  }

  function appendTableRow(tbody, item) {
    if (!tbody) return;
    tbody.insertAdjacentHTML("beforeend", renderTableRow(item));
    bindTableRowImageFallback(tbody.lastElementChild, item);
  }

  function hasMoreToLoad() {
    if (state.totalCount > 0) {
      return (
        state.apiOffset < state.totalCount ||
        state.lastPageRawCount >= state.lastFetchLimit
      );
    }
    return state.lastPageRawCount >= state.lastFetchLimit;
  }

  function updateResultMeta() {
    var root = getRoot();
    if (!root) return;
    var meta = root.querySelector("[data-gemstone-result-meta]");
    var totalEl = meta ? meta.querySelector("[data-gemstone-result-total]") : null;
    var loadMoreWrap = root.querySelector("[data-gemstone-load-more-wrap]");

    if (meta && totalEl) {
      var displayTotal = state.totalCount > state.items.length ? state.totalCount : state.items.length;
      totalEl.textContent = displayTotal.toLocaleString();
      meta.hidden = state.items.length === 0;
    }

    if (loadMoreWrap) {
      var show = state.items.length > 0 && hasMoreToLoad();
      loadMoreWrap.hidden = !show;
      loadMoreWrap.classList.toggle("is-visible", show);
    }
  }

  function renderAllItems() {
    var grid = getGrid();
    var tbody = getTableBody();
    if (grid) grid.innerHTML = "";
    if (tbody) tbody.innerHTML = "";

    var gridPosition = 0;
    state.items.forEach(function (item, index) {
      gridPosition = appendPromoIfNeeded(grid, index, gridPosition);
      if (grid) {
        var node = createCardNode(item);
        if (node) grid.appendChild(node);
      }
      if (tbody) appendTableRow(tbody, item);
      gridPosition += 1;
    });
  }

  function parseProxyJsonResponse(response) {
    return response.text().then(function (text) {
      var payload = {};
      var trimmed = (text || "").trim();

      if (trimmed) {
        if (trimmed.charAt(0) === "<") {
          throw new Error(
            "Nivoda app proxy is unavailable (received HTML instead of JSON). Restart nivoda-product-sync/start-dev.ps1, open the install URL it prints, then hard-refresh this page.",
          );
        }
        try {
          payload = JSON.parse(trimmed);
        } catch (parseError) {
          throw new Error(
            "Nivoda app proxy returned an invalid response. Restart start-dev.ps1, reinstall the app on this store, then hard-refresh this page.",
          );
        }
      }

      if (response.status === 511) {
        throw new Error(
          "Tunnel blocked the request (511). Restart nivoda-product-sync/start-dev.ps1 and use the new Cloudflare tunnel URL.",
        );
      }
      if (response.status === 500) {
        throw new Error(
          "Proxy request failed (500). The Nivoda app tunnel may be down — restart nivoda-product-sync/start-dev.ps1, then refresh this page.",
        );
      }
      if (!response.ok) {
        var errMsg =
          (payload && payload.error) ||
          "Proxy request failed (" + response.status + ").";
        throw new Error(errMsg);
      }

      return payload;
    });
  }

  function loadGemstones(append) {
    var root = getRoot();
    if (!root) return Promise.resolve();

    if (state.loading) {
      if (!append) {
        state.pendingReload = true;
        syncUrlFromUi();
      }
      return Promise.resolve();
    }

    var filters = getFilters();
    var requestId = ++state.requestId;

    if (!append) {
      syncFiltersToUrl(filters);
      state.apiOffset = 0;
      state.lastPageRawCount = 0;
      state.totalCount = 0;
      state.items = [];
      if (getGrid()) getGrid().innerHTML = "";
      if (getTableBody()) getTableBody().innerHTML = "";
      setPanelMessage("");
    }

    setLoading(true, append);

    var fetchLimit = getFetchLimit(append);

    return fetch(buildProxyUrl(filters, state.apiOffset, fetchLimit))
      .then(function (res) {
        return parseProxyJsonResponse(res);
      })
      .then(function (data) {
        if (requestId !== state.requestId) return;
        if (data.error) throw new Error(data.error);

        var rawItems = data.items || [];
        var apiTotal = Number(data.total_count || 0);

        if (!append) state.totalCount = apiTotal;
        else if (apiTotal > state.totalCount) state.totalCount = apiTotal;

        // A proxy-side filter may return fewer rows than Nivoda consumed. Using
        // that smaller displayed count repeats part of the previous API page.
        var rawPageCount = Number(data.raw_count);
        state.lastPageRawCount = isFinite(rawPageCount)
          ? rawPageCount
          : rawItems.length;
        state.lastFetchLimit = fetchLimit;
        var nextOffset = Number(data.next_offset);
        if (isFinite(nextOffset) && nextOffset > state.apiOffset) {
          state.apiOffset = nextOffset;
        } else if (rawItems.length || state.apiOffset < state.totalCount) {
          state.apiOffset += fetchLimit;
        }

        state.items = append ? state.items.concat(rawItems) : rawItems;

        if (!rawItems.length && !append) {
          setPanelMessage("No gemstones match these filters. Try widening your search.", false);
        }

        renderAllItems();
        updateResultMeta();
      })
      .catch(function (err) {
        if (requestId !== state.requestId) return;
        setPanelMessage(
          (err && err.message) ||
            "Unable to load gemstones. Check that your Nivoda proxy is running and the proxy URL is correct.",
          true,
        );
      })
      .finally(function () {
        if (requestId !== state.requestId) return;
        setLoading(false);
        if (state.pendingReload) {
          state.pendingReload = false;
          loadGemstones(false);
        }
      });
  }

  function clearFilters() {
    var root = getRoot();
    if (!root) return;
    var defaults = getFilterDefaults();

    root.querySelectorAll('[data-gemstone-filter="variety"], [data-gemstone-filter="shape"], [data-gemstone-filter="color"], [data-gemstone-filter="clarity"], [data-gemstone-filter="cut"]').forEach(function (input) {
      input.value = "";
    });

    root.querySelectorAll(".rb-filter-pill.is-active").forEach(function (pill) {
      pill.classList.remove("is-active");
    });

    root.querySelectorAll("[data-gemstone-shape-swatch]").forEach(function (btn) {
      btn.classList.remove("is-active", "is-selected");
      btn.setAttribute("aria-pressed", "false");
    });

    var caratMin = root.querySelector('[data-gemstone-filter="carat_min"]');
    var caratMax = root.querySelector('[data-gemstone-filter="carat_max"]');
    var priceMin = root.querySelector('[data-gemstone-filter="price_min"]');
    var priceMax = root.querySelector('[data-gemstone-filter="price_max"]');
    if (caratMin) caratMin.value = defaults.caratMin;
    if (caratMax) caratMax.value = defaults.caratMax;
    if (priceMin) priceMin.value = defaults.priceMin;
    if (priceMax) priceMax.value = defaults.priceMax;

    root.querySelectorAll('[data-gemstone-range="carat_min"]').forEach(function (el) {
      el.value = defaults.caratMin;
    });
    root.querySelectorAll('[data-gemstone-range="carat_max"]').forEach(function (el) {
      el.value = defaults.caratMax;
    });
    root.querySelectorAll('[data-gemstone-range="price_min"]').forEach(function (el) {
      el.value = defaults.priceMin;
    });
    root.querySelectorAll('[data-gemstone-range="price_max"]').forEach(function (el) {
      el.value = defaults.priceMax;
    });

    var caratSlider = root.querySelector("#gemstone-carat-slider");
    if (caratSlider && caratSlider.noUiSlider) {
      caratSlider.noUiSlider.set([Number(defaults.caratMin), Number(defaults.caratMax)]);
    }
    var priceSlider = root.querySelector("#gemstone-price-slider");
    if (priceSlider && priceSlider.noUiSlider) {
      priceSlider.noUiSlider.set([Number(defaults.priceMin), Number(defaults.priceMax)]);
    }

    syncFiltersToUrl(getFilters());
  }

  function setViewMode(mode) {
    var root = getRoot();
    if (!root) return;
    state.viewMode = mode === "table" ? "table" : "grid";
    root.setAttribute("data-view", state.viewMode);

    root.querySelectorAll("[data-gemstone-view]").forEach(function (btn) {
      var active = btn.getAttribute("data-gemstone-view") === state.viewMode;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    var grid = getGrid();
    var tableWrap = root.querySelector(".ring-builder-diamonds__table-wrap");
    var isGrid = state.viewMode === "grid";
    if (grid) {
      grid.hidden = !isGrid;
      grid.style.display = isGrid ? "" : "none";
    }
    if (tableWrap) {
      tableWrap.hidden = isGrid;
      tableWrap.style.display = isGrid ? "none" : "";
    }
  }

  function populateGemstoneSpecGrid(container, item) {
    if (!container) return;
    var values = {
      carat: formatCaratDisplay(item.carats),
      color: formatLabel(item.color, COLOR_LABELS),
      clarity: formatLabel(item.clarity, CLARITY_LABELS),
      cut: formatLabel(item.cut),
      ratio: formatGemstoneRatio(item),
      measurements: formatLengthWidth(item),
    };

    Object.keys(values).forEach(function (key) {
      var el = container.querySelector('[data-gemstone-detail-spec="' + key + '"]');
      if (!el) return;
      el.textContent = values[key] || "—";
      if (key === "measurements" && values[key] !== "—") {
        el.title = formatDimensions(item) || values[key];
      } else {
        el.removeAttribute("title");
      }
    });
  }

  function renderGemstoneDetailMedia(detailView, item, title) {
    var mediaContainer = detailView.querySelector("[data-gemstone-detail-media]");
    var mediaThumbs = detailView.querySelector("[data-gemstone-detail-media-thumbs]");
    if (!mediaContainer) return;

    var activeMediaMode = item.video ? "video" : item.image ? "image" : "none";

    function refreshMedia() {
      var embed = getGemstoneMediaEmbedSize(mediaContainer);
      if (activeMediaMode === "video" && item.video) {
        mediaContainer.removeAttribute("data-embed-width");
        mediaContainer.removeAttribute("data-embed-height");
        if (String(item.video).match(/\.(mp4|webm|mov)(\?|$)/i)) {
          mediaContainer.innerHTML =
            '<video src="' +
            escapeHtml(item.video) +
            '" controls autoplay loop playsinline class="diamond-detail-view__media-img"></video>';
          return;
        }
        mediaContainer.innerHTML =
          '<iframe class="diamond-detail-view__media-embed" src="' +
          escapeHtml(resizeNivodaMediaUrl(item.video, embed.width, embed.height)) +
          '" title="' +
          escapeHtml(title) +
          ' 360 video" frameborder="0" scrolling="no" allowfullscreen allow="autoplay; fullscreen; gyroscope; accelerometer"></iframe>';
        return;
      }

      if (activeMediaMode === "image" && item.image) {
        mediaContainer.removeAttribute("data-embed-width");
        mediaContainer.removeAttribute("data-embed-height");
        mediaContainer.innerHTML =
          '<img class="diamond-detail-view__media-img" src="' +
          escapeHtml(resizeNivodaMediaUrl(item.image, embed.width, embed.height)) +
          '" alt="' +
          escapeHtml(title) +
          '">';
        return;
      }

      mediaContainer.removeAttribute("data-embed-width");
      mediaContainer.removeAttribute("data-embed-height");
      mediaContainer.innerHTML = renderDiamondPlaceholderImage(
        "diamond-detail-view__media-img diamond-detail-view__media-img--placeholder",
        title,
      );
    }

    function scheduleMediaRender() {
      [0, 50, 150, 400].forEach(function (delay) {
        window.setTimeout(function () {
          requestAnimationFrame(refreshMedia);
        }, delay);
      });
    }

    if (mediaThumbs) {
      mediaThumbs.innerHTML = "";
      if (item.video && item.image) {
        var videoBtn = document.createElement("button");
        var imageBtn = document.createElement("button");
        videoBtn.type = "button";
        imageBtn.type = "button";
        videoBtn.textContent = "360° Video";
        imageBtn.textContent = "Gemstone Image";
        videoBtn.className = activeMediaMode === "video" ? "is-active" : "";
        imageBtn.className = activeMediaMode === "image" ? "is-active" : "";
        videoBtn.addEventListener("click", function (e) {
          e.preventDefault();
          activeMediaMode = "video";
          videoBtn.classList.add("is-active");
          imageBtn.classList.remove("is-active");
          scheduleMediaRender();
        });
        imageBtn.addEventListener("click", function (e) {
          e.preventDefault();
          activeMediaMode = "image";
          imageBtn.classList.add("is-active");
          videoBtn.classList.remove("is-active");
          scheduleMediaRender();
        });
        mediaThumbs.appendChild(videoBtn);
        mediaThumbs.appendChild(imageBtn);
      }

      appendCertificateThumbButton(mediaThumbs, item);
    }

    scheduleMediaRender();
  }

  var alternativesAbortController = null;
  var alternativesClickBound = false;

  var GEMSTONE_CLARITY_RANK = {
    EC: 0,
    EC1: 0,
    EC2: 0,
    SI: 1,
    MI: 2,
    VI1: 3,
    VI2: 4,
  };

  function normalizeGradeKey(value) {
    return String(value || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "");
  }

  function getClarityRank(clarity) {
    var key = normalizeGradeKey(clarity);
    return Object.prototype.hasOwnProperty.call(GEMSTONE_CLARITY_RANK, key)
      ? GEMSTONE_CLARITY_RANK[key]
      : 99;
  }

  function getWholesalePrice(item) {
    var value = Number(item && item.price);
    return isFinite(value) ? value : Number.POSITIVE_INFINITY;
  }

  function getQualityScore(item) {
    return getClarityRank(item.clarity);
  }

  function buildAlternativesFilters(item) {
    var carats = Number(item.carats);
    if (!isFinite(carats) || carats <= 0) carats = 1;

    var caratMin = Math.max(0.3, Number((carats * 0.9).toFixed(2)));
    var caratMax = Number((carats * 1.1).toFixed(2));

    return {
      variety: String(item.gemType || "").toUpperCase(),
      shape: String(item.shape || "").toUpperCase(),
      carat_min: String(caratMin),
      carat_max: String(caratMax),
      color: String(item.color || "").toUpperCase(),
      sort: "price_asc",
    };
  }

  function getMatchScore(currentItem, candidate) {
    var varietyMatch =
      normalizeGradeKey(currentItem.gemType) === normalizeGradeKey(candidate.gemType) ? 0 : 40;
    var shapeMatch =
      normalizeShapeKey(currentItem.shape) === normalizeShapeKey(candidate.shape) ? 0 : 50;
    var colorMatch =
      normalizeGradeKey(currentItem.color) === normalizeGradeKey(candidate.color) ? 0 : 25;
    var caratDiff = Math.abs(Number(currentItem.carats) - Number(candidate.carats));
    var clarityDiff = Math.abs(
      getClarityRank(currentItem.clarity) - getClarityRank(candidate.clarity),
    );
    return varietyMatch + shapeMatch + colorMatch + caratDiff * 20 + clarityDiff * 6;
  }

  function pickBestAlternatives(currentItem, items) {
    var currentId = String((currentItem && currentItem.offerId) || "");
    var pool = (items || [])
      .filter(function (candidate) {
        return candidate && candidate.offerId && String(candidate.offerId) !== currentId;
      })
      .sort(function (a, b) {
        return getMatchScore(currentItem, a) - getMatchScore(currentItem, b);
      });

    if (!pool.length) return [];

    var byPrice = pool.slice().sort(function (a, b) {
      return getWholesalePrice(a) - getWholesalePrice(b);
    });
    var bestPrice = byPrice[0];

    var byUpgrade = pool
      .filter(function (candidate) {
        return getQualityScore(candidate) < getQualityScore(currentItem);
      })
      .sort(function (a, b) {
        var qualityDiff = getQualityScore(a) - getQualityScore(b);
        if (qualityDiff !== 0) return qualityDiff;
        return getMatchScore(currentItem, a) - getMatchScore(currentItem, b);
      });
    var bestUpgrade = byUpgrade[0] || pool[0];

    var byValue = pool.slice().sort(function (a, b) {
      var valueA = getWholesalePrice(a) / Math.max(0.01, Number(a.carats) || 0.01);
      var valueB = getWholesalePrice(b) / Math.max(0.01, Number(b.carats) || 0.01);
      var scoreA = valueA * (1 + getQualityScore(a) * 0.02);
      var scoreB = valueB * (1 + getQualityScore(b) * 0.02);
      return scoreA - scoreB;
    });
    var bestValue = byValue[0];

    var selected = [];
    var used = {};

    function pushLabeled(label, candidate) {
      if (!candidate || !candidate.offerId) return;
      var id = String(candidate.offerId);
      if (used[id]) return;
      used[id] = true;
      selected.push({ label: label, item: candidate });
    }

    pushLabeled("Best Value", bestValue);
    pushLabeled("Best Price", bestPrice);
    pushLabeled("Best Upgrade", bestUpgrade);

    pool.forEach(function (candidate) {
      if (selected.length >= 3) return;
      pushLabeled("Best Match", candidate);
    });

    return selected.slice(0, 3);
  }

  function setAlternativesStatus(message) {
    var detailView = document.getElementById("GemstoneDetailView");
    if (!detailView) return;
    var statusEl = detailView.querySelector("[data-gemstone-alternatives-status]");
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = "";
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function renderAlternativeCard(entry) {
    var node = createCardNode(entry.item);
    if (!node) return null;

    node.classList.add("diamond-alternatives__item");
    node.setAttribute("data-gemstone-alternative-card", "true");

    var badgeEl = node.querySelector('[data-gemstone-field="selling-badge"]');
    if (badgeEl && entry.label) {
      badgeEl.textContent = entry.label;
      badgeEl.hidden = false;
    }

    node.classList.remove("col-lg-3");
    if (!node.classList.contains("col-lg-4")) {
      node.classList.add("col-lg-4");
    }

    return node;
  }

  function bindGemstoneAlternativesClicks() {
    if (alternativesClickBound) return;
    var detailView = document.getElementById("GemstoneDetailView");
    if (!detailView) return;
    alternativesClickBound = true;
    detailView.addEventListener("click", function (event) {
      var card = event.target.closest("[data-gemstone-alternative-card]");
      if (!card || !detailView.contains(card)) return;
      event.preventDefault();
      event.stopPropagation();

      var selectBtn = card.querySelector("[data-gemstone-select]");
      var payload = selectBtn
        ? selectBtn.getAttribute("data-gemstone-payload")
        : card.getAttribute("data-gemstone-payload");
      if (!payload) return;
      try {
        openGemstonePreview(JSON.parse(payload));
        window.scrollTo({
          top: Math.max(0, detailView.offsetTop - 80),
          behavior: "smooth",
        });
      } catch (e) {}
    });
  }

  function loadGemstoneAlternatives(item) {
    var detailView = document.getElementById("GemstoneDetailView");
    if (!detailView || !item) return;

    var section = detailView.querySelector("[data-gemstone-alternatives]");
    var grid = detailView.querySelector("[data-gemstone-alternatives-grid]");
    if (!section || !grid) return;

    bindGemstoneAlternativesClicks();

    if (alternativesAbortController) {
      alternativesAbortController.abort();
    }
    alternativesAbortController =
      typeof AbortController !== "undefined" ? new AbortController() : null;

    section.hidden = false;
    grid.innerHTML = "";
    setAlternativesStatus("Finding similar gemstones…");

    var filters = buildAlternativesFilters(item);
    var url = buildProxyUrl(filters, 0, 24);
    var fetchOptions = alternativesAbortController
      ? { signal: alternativesAbortController.signal }
      : {};

    fetch(url, fetchOptions)
      .then(function (response) {
        if (!response.ok) throw new Error("Alternatives request failed");
        return parseProxyJsonResponse(response);
      })
      .then(function (data) {
        var picks = pickBestAlternatives(item, (data && data.items) || []);
        if (!picks.length) {
          section.hidden = true;
          grid.innerHTML = "";
          setAlternativesStatus("");
          return;
        }
        setAlternativesStatus("");
        var fragment = document.createDocumentFragment();
        picks.forEach(function (entry) {
          var node = renderAlternativeCard(entry);
          if (node) fragment.appendChild(node);
        });
        grid.appendChild(fragment);
        section.hidden = false;
      })
      .catch(function (error) {
        if (error && error.name === "AbortError") return;
        section.hidden = true;
        grid.innerHTML = "";
        setAlternativesStatus("");
      });
  }

  function openGemstonePreview(item) {
    var detailView = document.getElementById("GemstoneDetailView");
    var root = getRoot();
    if (!detailView || !root || !item) return;

    var title = formatGemstoneTitle(item);
    var titleEl = detailView.querySelector("#GemstoneDetailTitle");
    if (titleEl) titleEl.textContent = title;

    var priceEl = detailView.querySelector("[data-gemstone-detail-price]");
    if (priceEl) priceEl.textContent = formatPrice(item.price);

    populateDetailLabBadgeLink(detailView, item);

    var skuEl = detailView.querySelector("[data-gemstone-detail-sku]");
    if (skuEl) {
      skuEl.textContent = "SKU: " + (item.certNumber || item.offerId || item.gemstoneId || "—");
    }

    var deliveryEl = detailView.querySelector("[data-gemstone-detail-delivery]");
    if (deliveryEl) deliveryEl.textContent = formatDeliveryRange(30, 35);

    populateGemstoneSpecGrid(detailView.querySelector("[data-gemstone-detail-specs]"), item);

    var descriptionEl = detailView.querySelector("[data-gemstone-detail-description]");
    if (descriptionEl) descriptionEl.innerHTML = buildGemstoneDescriptionHtml(item);

    renderGemstoneDetailMedia(detailView, item, title);

    var addBtn = detailView.querySelector("[data-gemstone-detail-add-to-cart]");
    if (addBtn) {
      var newAddBtn = addBtn.cloneNode(true);
      addBtn.parentNode.replaceChild(newAddBtn, addBtn);
      var addLabel = (newAddBtn.textContent || "Add This Gemstone To Cart").trim();
      newAddBtn.addEventListener("click", function (e) {
        e.preventDefault();
        newAddBtn.disabled = true;
        newAddBtn.textContent = "Adding…";
        handleAddToCart(item, newAddBtn, addLabel);
      });
    }

    var backBtn = detailView.querySelector("[data-gemstone-back-to-search]");
    if (backBtn) {
      var newBackBtn = backBtn.cloneNode(true);
      backBtn.parentNode.replaceChild(newBackBtn, backBtn);
      newBackBtn.addEventListener("click", function (e) {
        e.preventDefault();
        showGemstoneSearchLayout(root);
        window.setTimeout(function () {
          var rect = root.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          window.scrollTo({ top: rect.top + scrollTop - 150, behavior: "smooth" });
        }, 100);
      });
    }

    hideGemstoneSearchLayout(root);
    detailView.style.display = "block";
    loadGemstoneAlternatives(item);
    window.setTimeout(function () {
      var rect = root.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({ top: rect.top + scrollTop - 150, behavior: "smooth" });
    }, 100);
  }

  function initShapeSlider() {
    var root = getRoot();
    if (!root) return;

    root.querySelectorAll("[data-gemstone-shape-slider]").forEach(function (slider) {
      if (slider.dataset.shapeSliderInit === "true") return;
      slider.dataset.shapeSliderInit = "true";

      var track = slider.querySelector("[data-gemstone-shape-track]");
      var prevBtn = slider.querySelector("[data-gemstone-shape-prev]");
      var nextBtn = slider.querySelector("[data-gemstone-shape-next]");
      if (!track) return;

      function updateNav() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var slop = 2;
        var canScroll = maxScroll > slop;
        if (prevBtn) {
          prevBtn.hidden = !canScroll;
          prevBtn.disabled = !canScroll || track.scrollLeft <= slop;
        }
        if (nextBtn) {
          nextBtn.hidden = !canScroll;
          nextBtn.disabled = !canScroll || track.scrollLeft >= maxScroll - slop;
        }
      }

      function scrollByDirection(dir) {
        track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.75, 120), behavior: "smooth" });
      }

      if (prevBtn) prevBtn.addEventListener("click", function () { scrollByDirection(-1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { scrollByDirection(1); });
      track.addEventListener("scroll", updateNav, { passive: true });
      if (typeof ResizeObserver !== "undefined") {
        new ResizeObserver(updateNav).observe(track);
      } else {
        window.addEventListener("resize", updateNav);
      }
      updateNav();
    });
  }

  function initSliders() {
    var root = getRoot();
    if (!root || typeof noUiSlider === "undefined") return;
    var defaults = getFilterDefaults();

    var caratSlider = root.querySelector("#gemstone-carat-slider");
    if (caratSlider && !caratSlider.noUiSlider) {
      var caratMinInput = root.querySelector('[data-gemstone-filter="carat_min"]');
      var caratMaxInput = root.querySelector('[data-gemstone-filter="carat_max"]');
      var caratMin = Number(defaults.caratMin) || 1;
      var caratMax = Number(defaults.caratMax) || 10;

      noUiSlider.create(caratSlider, {
        start: [caratMin, caratMax],
        connect: true,
        step: 0.01,
        range: { min: caratMin, max: caratMax },
      });

      caratSlider.noUiSlider.on("update", function (values) {
        var min = parseFloat(values[0]).toFixed(2);
        var max = parseFloat(values[1]).toFixed(2);
        if (caratMinInput) caratMinInput.value = min;
        if (caratMaxInput) caratMaxInput.value = max;
        root.querySelectorAll('[data-gemstone-range="carat_min"]').forEach(function (el) { el.value = min; });
        root.querySelectorAll('[data-gemstone-range="carat_max"]').forEach(function (el) { el.value = max; });
      });
      caratSlider.noUiSlider.on("change", function () { scheduleFilterReload(); });
    }

    var priceSlider = root.querySelector("#gemstone-price-slider");
    if (priceSlider && !priceSlider.noUiSlider) {
      var priceMinInput = root.querySelector('[data-gemstone-filter="price_min"]');
      var priceMaxInput = root.querySelector('[data-gemstone-filter="price_max"]');
      var priceMin = Number(defaults.priceMin) || 1;
      var priceMax = Number(defaults.priceMax) || 5000000;

      noUiSlider.create(priceSlider, {
        start: [priceMin, priceMax],
        connect: true,
        step: 100,
        range: { min: priceMin, max: priceMax },
      });

      priceSlider.noUiSlider.on("update", function (values) {
        var min = Math.round(values[0]);
        var max = Math.round(values[1]);
        if (priceMinInput) priceMinInput.value = min;
        if (priceMaxInput) priceMaxInput.value = max;
        root.querySelectorAll('[data-gemstone-range="price_min"]').forEach(function (el) { el.value = min; });
        root.querySelectorAll('[data-gemstone-range="price_max"]').forEach(function (el) { el.value = max; });
      });
      priceSlider.noUiSlider.on("change", function () { scheduleFilterReload(); });
    }
  }

  function getProductSyncBaseUrl() {
    var el = document.querySelector("[data-nivoda-product-sync-base]");
    var base = el
      ? (el.getAttribute("data-nivoda-product-sync-base") || "").replace(/\/+$/, "")
      : "";

    if (/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(base)) {
      return NIVODA_LIVE_PROXY_BASE;
    }

    return base || NIVODA_LIVE_PROXY_BASE;
  }

  function buildGemstoneCartProperties(item) {
    return {
      "Gemstone Certificate": item.certNumber || item.offerId || "",
      stock_no: item.offerId || item.gemstoneId || "",
      stone_shape: formatLabel(item.shape),
      laboratory: item.lab || "",
      carat_weight: item.carats != null ? String(item.carats) : "",
      clarity: formatLabel(item.clarity, CLARITY_LABELS),
      color: formatLabel(item.color, COLOR_LABELS),
      stone_type: "Natural Gemstone",
      cut: formatLabel(item.cut),
      variety: formatLabel(item.gemType),
      _nivoda_offer_id: item.offerId || "",
      _price: String(item.price != null ? item.price : ""),
    };
  }

  function ensureGemstoneForCart(item) {
    var proxyBase = getProductSyncBaseUrl();
    if (!proxyBase) {
      return Promise.reject(new Error("Nivoda proxy URL is not configured."));
    }

    return fetch(proxyBase + "/gemstone/ensure-product", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        gemstone: item,
        margin:
          window.RingBuilderDiamondMargin &&
          typeof window.RingBuilderDiamondMargin.getMarginPayload === "function"
            ? window.RingBuilderDiamondMargin.getMarginPayload()
            : undefined,
      }),
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          var errMsg = (payload && payload.error) || "Unable to prepare gemstone product.";
          if (payload && payload.fallback) {
            errMsg = "Shopify Admin API is not configured for gemstone product sync.";
          }
          throw new Error(errMsg);
        }
        return payload;
      });
    });
  }

  function addGemstoneLineToCart(item, button, originalText) {
    return ensureGemstoneForCart(item)
      .then(function (result) {
        var properties = result.properties || buildGemstoneCartProperties(item);
        if (result.productId && !properties._product_id) {
          properties._product_id = String(result.productId);
        }
        return fetch("/cart/add.js?_fd=0", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{
              id: parseInt(result.variantId, 10),
              quantity: 1,
              properties: properties,
            }],
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error("Cart add failed");
          return res.json();
        }).then(function () {
          if (window.RingBuilderCartCleanup && result.productId) {
            window.RingBuilderCartCleanup.trackProductId(result.productId);
          }
        });
      })
      .catch(function (error) {
        var sectionEl = document.querySelector(".if_nivoda_gemstones");
        var placeholderVariantId = sectionEl
          ? sectionEl.getAttribute("data-placeholder-gemstone-variant-id")
          : "";
        if (!placeholderVariantId) throw error;
        return fetch("/cart/add.js?_fd=0", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{
              id: parseInt(placeholderVariantId, 10),
              quantity: 1,
              properties: buildGemstoneCartProperties(item),
            }],
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error("Cart add failed");
          return res.json();
        });
      })
      .then(function () {
        window.location.href = "/cart?_fd=0";
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
        setPanelMessage("Unable to add gemstone to cart. Please contact us to purchase this stone.", true);
      });
  }

  function handleAddToCart(item, button, originalText) {
    if (!item) return;
    addGemstoneLineToCart(item, button, originalText);
  }

  function bindEvents() {
    var root = getRoot();
    if (!root || root.dataset.bound === "true") return;
    root.dataset.bound = "true";

    root.querySelectorAll("[data-gemstone-pill-group]").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var pill = e.target.closest(".rb-filter-pill");
        if (!pill || !group.contains(pill)) return;
        e.preventDefault();
        pill.classList.toggle("is-active");

        var pillGroup = group.getAttribute("data-gemstone-pill-group");
        var values = [];
        root.querySelectorAll('[data-gemstone-pill-group="' + pillGroup + '"] .rb-filter-pill.is-active').forEach(function (activePill) {
          var val = activePill.getAttribute("data-pill-value");
          if (!val) return;
          values.push(val.trim());
        });

        root.querySelectorAll('[data-gemstone-filter="' + pillGroup + '"]').forEach(function (hidden) {
          hidden.value = values.join(",");
        });

        scheduleFilterReload();
      });
    });

    root.querySelectorAll("[data-gemstone-shape-swatch]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var shape = btn.getAttribute("data-shape") || "";
        var shapeInput = root.querySelector('[data-gemstone-filter="shape"]');
        var isActive = btn.classList.contains("is-active");
        root.querySelectorAll("[data-gemstone-shape-swatch]").forEach(function (other) {
          other.classList.remove("is-active", "is-selected");
          other.setAttribute("aria-pressed", "false");
        });
        if (!isActive && shapeInput) {
          btn.classList.add("is-active", "is-selected");
          btn.setAttribute("aria-pressed", "true");
          shapeInput.value = shape;
        } else if (shapeInput) {
          shapeInput.value = "";
        }
        scheduleFilterReload();
      });
    });

    root.querySelectorAll("[data-gemstone-range]").forEach(function (input) {
      input.addEventListener("change", function () {
        var key = input.getAttribute("data-gemstone-range");
        var hidden = root.querySelector('[data-gemstone-filter="' + key + '"]');
        if (hidden) hidden.value = input.value;
        scheduleFilterReload();
      });
    });

    var sortRoot = root.querySelector("[data-gemstone-sort]");
    var sortTrigger = root.querySelector("[data-gemstone-sort-trigger]");
    if (sortTrigger) {
      sortTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = sortRoot && sortRoot.classList.contains("is-open");
        setGemstoneSortMenuOpen(!isOpen);
      });
    }
    root.querySelectorAll("[data-gemstone-sort-option]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        applySortFilter(btn.getAttribute("data-sort"));
        setGemstoneSortMenuOpen(false);
        scheduleFilterReload();
      });
    });
    if (!document.documentElement.dataset.rbGemstoneSortOutsideClick) {
      document.documentElement.dataset.rbGemstoneSortOutsideClick = "true";
      document.addEventListener("click", function (e) {
        var activeRoot = getRoot();
        if (!activeRoot) return;
        var activeSort = activeRoot.querySelector("[data-gemstone-sort]");
        if (!activeSort || !activeSort.classList.contains("is-open")) return;
        if (activeSort.contains(e.target)) return;
        setGemstoneSortMenuOpen(false);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        setGemstoneSortMenuOpen(false);
      });
    }

    var clearBtn = root.querySelector("#gemstone-btn-clear-filters");
    if (clearBtn) {
      clearBtn.addEventListener("click", function (e) {
        e.preventDefault();
        clearFilters();
        flushFilterReload();
      });
    }

    root.querySelectorAll("[data-gemstone-more-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = btn.getAttribute("data-gemstone-more-toggle");
        var wrap = root.querySelector('[data-gemstone-more-wrap="' + key + '"]');
        if (!wrap) return;
        var list = wrap.closest(".rb-filter-pills__list--variety");
        var expanded = !wrap.hidden;
        wrap.hidden = expanded;
        if (list) list.classList.toggle("is-expanded", !expanded);
        btn.textContent = expanded ? "More varieties" : "Fewer varieties";
      });
    });

    root.querySelectorAll("[data-gemstone-view]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setViewMode(btn.getAttribute("data-gemstone-view"));
      });
    });

    var loadMoreBtn = root.querySelector("[data-gemstone-load-more]");
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", function () { loadGemstones(true); });
    }

    root.addEventListener("click", function (e) {
      var selectBtn = e.target.closest("[data-gemstone-select]");
      if (selectBtn && root.contains(selectBtn)) {
        e.preventDefault();
        e.stopPropagation();
        try {
          openGemstonePreview(JSON.parse(selectBtn.getAttribute("data-gemstone-payload") || "{}"));
        } catch (err) {}
        return;
      }

      var tableRow = e.target.closest("tr[data-gemstone-card]");
      if (tableRow && root.contains(tableRow)) {
        e.preventDefault();
        try {
          openGemstonePreview(JSON.parse(tableRow.getAttribute("data-gemstone-payload") || "{}"));
        } catch (err) {}
        return;
      }

      var gridCard = e.target.closest("li[data-gemstone-card]");
      if (gridCard && root.contains(gridCard)) {
        e.preventDefault();
        try {
          openGemstonePreview(JSON.parse(gridCard.getAttribute("data-gemstone-payload") || "{}"));
        } catch (err) {}
      }
    });

    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      if (e.target.closest("[data-gemstone-select]")) return;
      var card = e.target.closest("[data-gemstone-card]");
      if (!card || !root.contains(card)) return;
      e.preventDefault();
      var payload = card.getAttribute("data-gemstone-payload") || "";
      try {
        openGemstonePreview(JSON.parse(payload || "{}"));
      } catch (err) {}
    });

    window.addEventListener("popstate", function () {
      if (!getRoot()) return;
      cancelScheduledFilterReload();
      var urlFilters = parseUrlToFilters();
      if (urlFilters) applyFiltersToUi(urlFilters);
      else clearFilters();
      loadGemstones(false);
    });
  }

  function init() {
    var root = getRoot();
    if (!root) return;
    bindEvents();
    initSliders();
    initShapeSlider();
    setViewMode("grid");

    if (!state.userHasEditedFilters) {
      var urlFilters = parseUrlToFilters();
      if (urlFilters) {
        applyFiltersToUi(urlFilters);
        root.dataset.filtersBootstrapped = "true";
      } else if (root.dataset.filtersBootstrapped !== "true") {
        clearFilters();
        applySortFilter(getDefaultGemstoneSort());
        root.dataset.filtersBootstrapped = "true";
      }
    } else {
      root.dataset.filtersBootstrapped = "true";
    }

    flushFilterReload();
  }

  return {
    init: init,
    loadGemstones: loadGemstones,
    buildGemstoneCartProperties: buildGemstoneCartProperties,
    ensureGemstoneForCart: ensureGemstoneForCart,
    addGemstoneLineToCart: addGemstoneLineToCart,
  };
})();
